import KeenSlider from "keen-slider";

import vars from "../../../../Styles/_variables.module.scss";

const CSS_SELECTOR = ".js-o-carousel",
	CSS_SELECTOR_SLIDE = ".js-o-carousel__slide",
	CSS_SELECTOR_CONTROL_LEFT = ".js-o-carousel__control-left",
	CSS_SELECTOR_CONTROL_RIGHT = ".js-o-carousel__control-right",
	CSS_SELECTOR_CONTROL_DOT = ".js-o-carousel__control-dot",
	//
	CSS_CLASS_LOADING = "o-carousel--loading",
	CSS_CLASS_CONTROL_DOT_ACTIVE = "o-carousel__control-dot--active",
	//
	ATTR_DATA_INITED = "data-o-carousel-inited";

_initCarousels();

function _initCarousels() {
	console.log("a")
	var $els = document.querySelectorAll(CSS_SELECTOR);

	for (var i = 0; i < ($els && $els.length); i++) {
		console.log("b")
		var $el = $els[i];
		_initCarousel($el);
	}
}

function _initCarousel($el) {
	console.log(1)
	if (!$el) return;
	if ($el.getAttribute(ATTR_DATA_INITED)) return;

	$el.setAttribute(ATTR_DATA_INITED, true);

	console.log(2)
	var spacing =
			(vars && vars.gapMaxSm && vars.gapMaxSm.replace("px", "") / 1) || 0,
		carousel = new KeenSlider($el, {
			selector: CSS_SELECTOR_SLIDE,
			loop: false,
			mode: "snap",
			slides: {
				origin: "center",
				perView: 1.2,
				spacing: spacing,
			},
			breakpoints: {
				"(min-width: 800px)": {
					slides: { perView: 2, spacing: spacing },
				},
				"(min-width: 1024px)": {
					slides: { perView: 3, spacing: spacing },
				},
			},
		});

	console.log(3)
	var $controlLeft = $el.querySelector(CSS_SELECTOR_CONTROL_LEFT),
		$controlRight = $el.querySelector(CSS_SELECTOR_CONTROL_RIGHT),
		$controlDots = $el.querySelectorAll(CSS_SELECTOR_CONTROL_DOT);

	if ($controlLeft) {
		$controlLeft.addEventListener("click", carousel.prev.bind(carousel));
	}

	if ($controlRight) {
		$controlRight.addEventListener("click", carousel.next.bind(carousel));
	}

	console.log(4)
	var fnToggleControlVisualState = _toggleControlVisualState.bind(
		null,
		carousel,
		$controlLeft,
		$controlRight,
		$controlDots
	);

	carousel.on("created", fnToggleControlVisualState);
	carousel.on("slideChanged", fnToggleControlVisualState);
	fnToggleControlVisualState();
	console.log(5)

	$el.classList.remove(CSS_CLASS_LOADING);
}

// show/hide controls, change state of dots
function _toggleControlVisualState(carousel, $left, $right, $dots) {
	if (!carousel) return;

	var activeSlide = carousel.track.details.abs,
		slidesLng = carousel.slides.length,
		perView = carousel.options.slides.perView;

	_toggle($left, activeSlide === 0);
	_toggle($right, activeSlide + perView >= slidesLng);

	_updateDots($dots);

	function _toggle($el, disable) {
		if (!$el) return;
		if (disable) return $el.setAttribute("disabled", true);
		$el.removeAttribute("disabled");
	}

	function _updateDots($dots) {
		if (!$dots) return;

		for (var i = 0; i < $dots.length; i++) {
			var $dot = $dots[i];
			$dot.classList.remove(CSS_CLASS_CONTROL_DOT_ACTIVE);
		}

		var $activeDot = $dots[activeSlide];
		if ($activeDot) $activeDot.classList.add(CSS_CLASS_CONTROL_DOT_ACTIVE);
	}
}
